/**
 * Sentry Event Types
 * Used to tag events in Sentry for better filtering and analysis
 */

export const SENTRY_EVENT_TYPES = {
  SESSION_START: 'session_start',
  VIEWED_TUTORIAL_VIDEO: 'viewed_tutorial_video',
  /** Emitted when the user reaches Step3 (capture flow), before opening the camera. */
  STARTED_TEST: 'started_test',
  MODEL_LOADED: 'model_loaded',
  OPENED_CAMERA: 'opened_camera',
  STACK_IS_FULL: 'stack_is_full',
  CAMERA_CLOSE: 'camera_close',
  COMPLETED_TEST: 'completed_test',
  COMPLETED_TEST_WITH_ISSUE: 'completed_test_with_issue',
  RESULT_SUBMITTED: 'result_submitted',
  USER_SELF_REPORTED_RESULT: 'user_self_reported_result',
  MODEL_RESULT: 'model_result',
  IMAGE_UPLOAD: 'image_upload',
  /** Emitted once per REJECTED ("not sure") classification attempt (up to 3). */
  NOT_SURE_RESULT: 'not_sure_result',
  /** Used with storage_status Sentry tag to monitor localStorage reliability in WebViews */
  STORAGE_STATUS: 'storage_status',
} as const;

export type SentryEventType = typeof SENTRY_EVENT_TYPES[keyof typeof SENTRY_EVENT_TYPES];


